import Breadcrumbs from "components/Breadcrumbs";
import ImageWithText from "components/ImageWithText";
import SEO from "components/SEO";
import { pagePadding } from "data/commonClasses";
import { fetchParallel } from "functions";
import useTranslation from "translations/hooks/useTranslation";

const PresidentWord = ({ data, lang }) => {
  const { t } = useTranslation();

  var breadcrumbs = [
    { text: t("home"), href: "/" },
    { text: t("presidentWord") },
  ];
  return (
    <div className={pagePadding}>
      <SEO title={t("presidentWord")} description={t("presidentWord")} />
      <Breadcrumbs items={breadcrumbs} />
      <ImageWithText data={data} lang={lang} />
    </div>
  );
};

export default PresidentWord;

export async function getServerSideProps(context) {
  let { lang } = context?.query;

  let body = { key: "president-word", lang };

  let requests = [
    {
      key: "data",
      apiName: "oea-pages-content",
      reqBody: body,
    },
  ];
  let fetchRes = await fetchParallel(requests);
  let data = fetchRes?.data?.response;

  return {
    props: {
      data,
      lang,
    },
  };
}
